import { Chip, createStyles, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Icons } from '@nutrien/cxp-components';
import React, { useEffect, useMemo, useState } from 'react';

import { IStyleButton } from '../../models/models';

const useStyles = makeStyles(() =>
  createStyles({
    outSpacing: {
      marginTop: '5px',
      marginBottom: '4px',
      '& .MuiChip-outlined': {
        border: '1px solid',
        color: '#6CD9C7',
        backgroundColor: 'rgba(39, 126, 126, 0.10)',
        margin: '5px 10px 0 0',
        '& .MuiChip-label': {
          fontSize: '14px',
        },
      },
    },
  }),
);

interface Props {
  inspector: IStyleButton | string;
  handleDeleteInspector?: (inspId: number) => void;
  count?: number;
  canDelete?: boolean | Promise<boolean>;
  datatestid?: string;
}

const StyledButton: React.FC<Props> = ({
  inspector,
  handleDeleteInspector,
  count,
  canDelete,
  datatestid = 'styledbutton',
}) => {
  const classes = useStyles();
  const typeString = typeof inspector === 'string';
  const [ableToDelete, setAbleToDelete] = useState(false);
  const label = useMemo(() => {
    if (!typeString) {
      return inspector?.fieldInspectorName
        ? inspector?.fieldInspectorName
        : inspector?.clerkName
        ? inspector?.clerkName
        : inspector?.firstName + ' ' + inspector?.lastName;
    } else {
      return inspector;
    }
  }, [inspector, typeString]);

  useEffect(() => {
    Promise.resolve(canDelete).then(value => {
      setAbleToDelete(value ? value : false);
    });
  }, [canDelete]);

  return (
    <Grid className={classes.outSpacing}>
      <Chip
        clickable
        variant="outlined"
        label={`${label} ${count && count > 0 ? `(${count})` : ''}`}
        onDelete={() =>
          handleDeleteInspector?.(
            ((inspector as IStyleButton)?.pkInspector as number)
              ? ((inspector as IStyleButton)?.pkInspector as number)
              : ((inspector as IStyleButton)?.fieldInspectorId as number),
          )
        }
        deleteIcon={
          typeString || !ableToDelete ? (
            <></>
          ) : (
            <Icons.MinusCircleFeather color="error" data-testid="deleteicon" />
          )
        }
        data-testid={datatestid}
      />
    </Grid>
  );
};

export default StyledButton;
